import React from 'react';
import { ArrowDownRight } from 'lucide-react';
import { galleryItems } from '../data/mockData';
import { AnimateOnScroll } from '../hooks/useScrollAnimation';

const GallerySection = () => {
  return (
    <section id="gallery" className="py-20 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <AnimateOnScroll>
          <div className="flex flex-col md:flex-row justify-between items-center md:items-end mb-12 md:mb-16 text-center md:text-left">
            <div>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white font-bold uppercase tracking-tight mb-4 italic">
                The <span className="gold-gradient">Vault</span>
              </h2>
              <p className="text-zinc-400 text-base md:text-lg max-w-md mx-auto md:mx-0">
                Proof is in the mirror. Check the latest masterpieces crafted by
                our team.
              </p>
            </div>
            <div className="mt-8 md:mt-0 hidden md:block">
              <ArrowDownRight className="text-primary w-12 h-12 animate-bounce" />
            </div>
          </div>
        </AnimateOnScroll>

        {/* Gallery Grid - Row 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-6">
          {/* Large Image */}
          <AnimateOnScroll className="lg:col-span-7">
            <div className="relative group overflow-hidden rounded-3xl border border-white/5 h-[400px] md:h-[500px] lg:h-[600px]">
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-80 z-10 transition-opacity duration-500 group-hover:opacity-100" />
              <img
                src={galleryItems[0].image}
                alt={galleryItems[0].alt}
                className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110 grayscale-[20%] group-hover:grayscale-0"
              />
              <div className="absolute bottom-0 left-0 p-6 md:p-8 z-20 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 w-full">
                <p className="font-heading text-primary font-bold text-xl md:text-2xl uppercase mb-1 italic">
                  {galleryItems[0].title}
                </p>
                {galleryItems[0].subtitle && (
                  <p className="text-zinc-300 text-sm">
                    {galleryItems[0].subtitle}
                  </p>
                )}
              </div>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Two Smaller Images */}
          <div className="lg:col-span-5 flex flex-col gap-4 sm:gap-6">
            {galleryItems.slice(1, 3).map((item, index) => (
              <AnimateOnScroll key={item.title} delay={(index + 1) * 100}>
                <div className="relative group overflow-hidden rounded-3xl border border-white/5 h-[300px] lg:h-[calc(300px-12px)]">
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-80 z-10 transition-opacity duration-500 group-hover:opacity-100" />
                  <img
                    src={item.image}
                    alt={item.alt}
                    className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110 grayscale-[20%] group-hover:grayscale-0"
                  />
                  <div className="absolute bottom-0 left-0 p-6 z-20 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 w-full">
                    <p className="font-heading text-primary font-bold text-lg md:text-xl uppercase italic">
                      {item.title}
                    </p>
                  </div>
                </div>
              </AnimateOnScroll>
            ))}
          </div>
        </div>

        {/* Gallery Grid - Row 2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mt-4 sm:mt-6">
          {galleryItems.slice(3).map((item, index) => (
            <AnimateOnScroll key={item.title} delay={(index + 3) * 100}>
              <div className="relative group overflow-hidden rounded-3xl border border-white/5 h-[300px] md:h-[350px]">
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-80 z-10 transition-opacity duration-500 group-hover:opacity-100" />
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110 grayscale-[20%] group-hover:grayscale-0"
                />
                <div className="absolute bottom-0 left-0 p-6 z-20 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 w-full">
                  <p className="font-heading text-primary font-bold text-lg md:text-xl uppercase italic">
                    {item.title}
                  </p>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
